import React, { FC } from 'react';

import { useFormikContext } from 'formik';

import TextInput from '../../../../components/inputs/textInput';
import styled from 'styled-components';

import aampeTheme from '../../../../constants/aampeTheme';

import { FormulaTestMessageFormValues } from '../../../../models/formula.model';

interface TestFormulaAttributeFieldsProps {
    contactId: string;
    providerAdditionalAttributes: Record<string, string>;
    userLabel?: string;
    noWrapper?: boolean;
}

const TestFormulaAttributeFields: FC<TestFormulaAttributeFieldsProps> = ({
    contactId,
    providerAdditionalAttributes,
    userLabel,
    noWrapper = false,
}) => {
    const { values, setFieldValue } =
        useFormikContext<FormulaTestMessageFormValues>();

    const keys = Object.keys(providerAdditionalAttributes);

    if (keys.length === 0) {
        return null;
    }

    const fields = keys.map((key) => (
        <TextInput
            key={key}
            label={`${key} (${providerAdditionalAttributes[key]})`}
            name={`integration_attribute_values__${contactId}__${key}`}
            type="text"
            value={
                values.integration_attribute_values?.[contactId]?.[key] ?? ''
            }
            onChange={(e) =>
                setFieldValue('integration_attribute_values', {
                    ...(values.integration_attribute_values ?? {}),
                    [contactId]: {
                        ...(values.integration_attribute_values ?? {})?.[
                            contactId
                        ],
                        [key]: e.target.value,
                    },
                })
            }
            inputStyle={{ width: '100%' }}
            wrapperStyle={{ width: '100%' }}
        />
    ));

    if (noWrapper) {
        return (
            <>
                <SectionLabel>
                    {userLabel
                        ? `Additional Provider Attributes — ${userLabel}`
                        : 'Additional Provider Attributes'}
                </SectionLabel>
                {fields}
            </>
        );
    }

    return (
        <Container>
            <Box>
                <SectionLabel>
                    {userLabel
                        ? `Additional Provider Attributes — ${userLabel}`
                        : 'Additional Provider Attributes'}
                </SectionLabel>
                {fields}
            </Box>
        </Container>
    );
};

const Container = styled.div({
    display: 'flex',
    flexDirection: 'column',
    gap: aampeTheme.spacing4(4),
    width: '100%',
    margin: aampeTheme.spacing4(4, 0),
});

const Box = styled.div({
    display: 'flex',
    flexDirection: 'column',
    gap: aampeTheme.spacing4(4),
    padding: aampeTheme.spacing4(3),
    border: `1px solid ${aampeTheme.colors.bordersWG01}`,
    borderRadius: aampeTheme.borderRadius.default,
});

const SectionLabel = styled.span({
    fontSize: aampeTheme.size.font.default,
    fontWeight: 500,
    color: aampeTheme.colors.neutral09,
});

export default TestFormulaAttributeFields;
